import { User } from "lucide-react";
import { useTranslation } from "react-i18next";

export const HeaderProfile = ({
  user,
  handleProfileEdit,
}: {
  user: any;
  handleProfileEdit: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-start justify-between mb-10">
      <div className="flex gap-5">
        <div className="w-20 h-20 rounded-xl bg-secondaryText/20 dark:bg-secondaryTextDark/20 flex items-center justify-center">
          <User className="w-11 h-11 text-secondaryText dark:text-secondaryTextDark" />
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-2xl font-semibold">
            {t("Hey,")} <span className="font-bold">{user?.name}</span>
          </p>

          {user?.city && (
            <p className="text-sm">
              <span className="font-medium">{t("City")}: </span> {user?.city}
            </p>
          )}

          {user?.email && (
            <div className="flex items-center gap-2 text-sm">
              <span>
                <span className="font-medium">{t("Email")}: </span>
                {user?.email}
              </span>
              <button className="px-2 py-0.5 text-xs rounded bg-secondaryText/80 dark:bg-secondaryTextDark text-primaryText hover:bg-secondaryText hover:dark:bg-secondaryTextDark/80 font-medium">
                {t("Verify")}
              </button>
            </div>
          )}

          {user?.phone && (
            <div className="flex items-center gap-2 text-sm">
              <span>
                <span className="font-medium">{t("Phone")}:</span> {user?.phone}
              </span>
              <button className="px-2 py-0.5 text-xs rounded bg-secondaryText/80 dark:bg-secondaryTextDark text-primaryText hover:bg-secondaryText hover:dark:bg-secondaryTextDark/80 font-medium">
                {t("Verify")}
              </button>
            </div>
          )}
        </div>
      </div>

      <button
        className="px-3 py-1.5 text-sm rounded bg-secondaryText/80 dark:bg-secondaryTextDark text-primaryText hover:bg-secondaryText hover:dark:bg-secondaryTextDark/80"
        onClick={handleProfileEdit}
      >
        {t("Edit Profile")}
      </button>
    </div>
  );
};
